import { authenticatedInstance } from 'api';

export const GET_NETWORKS = {
  STARTED: 'GET_NETWORKS_STARTED',
  SUCCESS: 'GET_NETWORKS_SUCCESS',
  FAIL: 'GET_NETWORKS_FAIL',
};

export const getNetworks = (currencyName) => {
  return async (dispatch) => {
    dispatch({ type: GET_NETWORKS.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: `/api/currencies/${currencyName}/assets`,
        method: 'GET',
      });

      dispatch({
        type: GET_NETWORKS.SUCCESS,
        payload: data.items,
      });
    } catch (e) {
      dispatch({ type: GET_NETWORKS.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};
